import Defs from '../primitives/colorDefs'
export default {

  methods: {

    gmx_Color2Sets() {
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'LightGray',   [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'Gray',        [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'DarkGray',    [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'Yellow',      [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'Gold',        [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'Orange',      [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'Pink',        [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'Violet',      [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'Red',         [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'Thistle',     [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'Purple',      [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'Indigo',      [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'LightBlue',   [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'SkyBlue',     [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'SteelBlue',   [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'YellowGreen', [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'DarkGreen',   [.5, 1, .5, -.5], this.localId)
    },
    
    gmx_Color4Sets() {
      Defs.setDefs_Gradients(this.svg, '', 'LinearA4', 'LightGray',   [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA4', 'Gray',        [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA4', 'DarkGray',    [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA4', 'Yellow',      [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA4', 'Gold',        [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA4', 'Orange',      [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA4', 'Pink',        [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA4', 'Violet',      [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA4', 'Red',         [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA4', 'Thistle',     [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA4', 'Purple',      [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA4', 'Indigo',      [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA4', 'LightBlue',   [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA4', 'SkyBlue',     [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA4', 'SteelBlue',   [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA4', 'YellowGreen', [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA4', 'DarkGreen',   [.5, 1, .5, -.5], this.localId)
    },

    gmx_ColorH2Sets() {
      Defs.setDefs_Gradients(this.svg, 'H2', 'LinearA2', 'LightGray',   [.5, 1., .5, .2], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H2', 'LinearA2', 'Gray',        [.5, 1., .5, .2], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H2', 'LinearA2', 'DarkGray',    [.5, 1., .5, .2], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H2', 'LinearA2', 'Yellow',      [.5, 1., .5, .2], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H2', 'LinearA2', 'Gold',        [.5, 1., .5, .2], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H2', 'LinearA2', 'Orange',      [.5, 1., .5, .2], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H2', 'LinearA2', 'Pink',        [.5, 1., .5, .2], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H2', 'LinearA2', 'Violet',      [.5, 1., .5, .2], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H2', 'LinearA2', 'Red',         [.5, 1., .5, .2], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H2', 'LinearA2', 'Thistle',     [.5, 1., .5, .2], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H2', 'LinearA2', 'Purple',      [.5, 1., .5, .2], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H2', 'LinearA2', 'Indigo',      [.5, 1., .5, .2], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H2', 'LinearA2', 'LightBlue',   [.5, 1., .5, .2], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H2', 'LinearA2', 'SkyBlue',     [.5, 1., .5, .2], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H2', 'LinearA2', 'SteelBlue',   [.5, 1., .5, .2], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H2', 'LinearA2', 'YellowGreen', [.5, 1., .5, .2], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H2', 'LinearA2', 'DarkGreen',   [.5, 1., .5, .2], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H2', 'LinearA2', 'BP',          [.5, 1., .5, .2], this.localId)
    },
    
    gmx_ColorH4Sets() {
      Defs.setDefs_Gradients(this.svg, 'H4', 'LinearA4', 'LightGray',   [.5, .9, .5, 0], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H4', 'LinearA4', 'Gray',        [.5, .9, .5, 0], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H4', 'LinearA4', 'DarkGray',    [.5, .9, .5, 0], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H4', 'LinearA4', 'Yellow',      [.5, .9, .5, 0], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H4', 'LinearA4', 'Gold',        [.5, .9, .5, 0], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H4', 'LinearA4', 'Orange',      [.5, .9, .5, 0], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H4', 'LinearA4', 'Pink',        [.5, .9, .5, 0], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H4', 'LinearA4', 'Violet',      [.5, .9, .5, 0], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H4', 'LinearA4', 'Red',         [.5, .9, .5, 0], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H4', 'LinearA4', 'Thistle',     [.5, .9, .5, 0], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H4', 'LinearA4', 'Purple',      [.5, .9, .5, 0], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H4', 'LinearA4', 'Indigo',      [.5, .9, .5, 0], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H4', 'LinearA4', 'LightBlue',   [.5, .9, .5, 0], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H4', 'LinearA4', 'SkyBlue',     [.5, .9, .5, 0], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H4', 'LinearA4', 'SteelBlue',   [.5, .9, .5, 0], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H4', 'LinearA4', 'YellowGreen', [.5, .9, .5, 0], this.localId)
      Defs.setDefs_Gradients(this.svg, 'H4', 'LinearA4', 'DarkGreen',   [.5, .9, .5, 0], this.localId)
    },

    gmx_ColorV2Sets() {
      Defs.setDefs_Gradients(this.svg, 'V2', 'LinearA2', 'LightGray',   [0, .5, 1, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V2', 'LinearA2', 'Gray',        [0, .5, 1, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V2', 'LinearA2', 'DarkGray',    [0, .5, 1, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V2', 'LinearA2', 'Yellow',      [0, .5, 1, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V2', 'LinearA2', 'Gold',        [0, .5, 1, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V2', 'LinearA2', 'Orange',      [0, .5, 1, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V2', 'LinearA2', 'Pink',        [0, .5, 1, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V2', 'LinearA2', 'Violet',      [0, .5, 1, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V2', 'LinearA2', 'Red',         [0, .5, 1, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V2', 'LinearA2', 'Thistle',     [0, .5, 1, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V2', 'LinearA2', 'Purple',      [0, .5, 1, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V2', 'LinearA2', 'Indigo',      [0, .5, 1, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V2', 'LinearA2', 'LightBlue',   [0, .5, 1, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V2', 'LinearA2', 'SkyBlue',     [0, .5, 1, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V2', 'LinearA2', 'SteelBlue',   [0, .5, 1, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V2', 'LinearA2', 'YellowGreen', [0, .5, 1, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V2', 'LinearA2', 'DarkGreen',   [0, .5, 1, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V2', 'LinearA2', 'BP',          [0, .5, 1, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V2', 'LinearA2', 'BP2',         [0, .5, 1, .5], this.localId)
    },
    
    gmx_ColorV4Sets() {
      Defs.setDefs_Gradients(this.svg, 'V4', 'LinearA4', 'LightGray',   [0, .5, 1.5, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V4', 'LinearA4', 'Gray',        [0, .5, 1.5, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V4', 'LinearA4', 'DarkGray',    [0, .5, 1.5, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V4', 'LinearA4', 'Yellow',      [0, .5, 1.5, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V4', 'LinearA4', 'Gold',        [0, .5, 1.5, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V4', 'LinearA4', 'Orange',      [0, .5, 1.5, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V4', 'LinearA4', 'Pink',        [0, .5, 1.5, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V4', 'LinearA4', 'Violet',      [0, .5, 1.5, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V4', 'LinearA4', 'Red',         [0, .5, 1.5, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V4', 'LinearA4', 'Thistle',     [0, .5, 1.5, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V4', 'LinearA4', 'Purple',      [0, .5, 1.5, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V4', 'LinearA4', 'Indigo',      [0, .5, 1.5, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V4', 'LinearA4', 'LightBlue',   [0, .5, 1.5, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V4', 'LinearA4', 'SkyBlue',     [0, .5, 1.5, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V4', 'LinearA4', 'SteelBlue',   [0, .5, 1.5, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V4', 'LinearA4', 'YellowGreen', [0, .5, 1.5, .5], this.localId)
      Defs.setDefs_Gradients(this.svg, 'V4', 'LinearA4', 'DarkGreen',   [0, .5, 1.5, .5], this.localId)
    },

    gmx_radialShadow() {
      let Shadow = this.svg
      .append('defs')
      .append('radialGradient').attr('id', `SHADOW_${this.localId}`)
      Shadow.append('stop').attr('stop-color', '#a4a4a4').attr('offset', '0.00').attr('stop-opacity', '1')
      Shadow.append('stop').attr('stop-color', '#ffffff').attr('offset', '1.00').attr('stop-opacity', '0.37')
    },

    set_Tube_Gradients() {
      let Shadow = this.svg
      .append('defs') // Shadow Left
      .append('radialGradient')
      .attr('id', `${this.localId}_Shadow`)
      Shadow.append('stop').attr('stop-color', '#a4a4a4').attr('offset', '0.00').attr('stop-opacity', '1')
      Shadow.append('stop').attr('stop-color', '#ffffff').attr('offset', '1.00').attr('stop-opacity', '0.1')


      let TubeBase = this.svg
      .append('defs') // d.base.height Cylinder
      .append('linearGradient')
      .attr('id', `${this.localId}_TubeBase`)

      TubeBase.append('stop').attr('stop-color', '#a9adb0').attr('offset', '0.00').attr('stop-opacity', '1')
      TubeBase.append('stop').attr('stop-color', '#f6f6f6').attr('offset', '0.60').attr('stop-opacity', '1')
      TubeBase.append('stop').attr('stop-color', '#f6f6f6').attr('offset', '1.00').attr('stop-opacity', '1')

      let TubeBox = this.svg
      .append('defs') // Tube Box
      .append('linearGradient')
      .attr('id', `${this.localId}_TubeBox`)

      TubeBox.append('stop').attr('stop-color', '#b4b4b4').attr('offset', '0.00').attr('stop-opacity', '0.50')
      TubeBox.append('stop').attr('stop-color', '#f2f2f2').attr('offset', '0.30').attr('stop-opacity', '0.15')
      TubeBox.append('stop').attr('stop-color', '#fff').attr('offset', '0.60').attr('stop-opacity', '0.01')
      TubeBox.append('stop').attr('stop-color', '#f2f2f2').attr('offset', '0.80').attr('stop-opacity', '0.15')
      TubeBox.append('stop').attr('stop-color', '#b4b4b4').attr('offset', '1.00').attr('stop-opacity', '0.50')

      let TubeCap = this.svg
      .append('defs') // Tube Cap
      .append('linearGradient')
      .attr('id', `${this.localId}_TubeCap`)

      TubeCap.append('stop').attr('stop-color', '#efefef').attr('offset', '0.00').attr('stop-opacity', '0.90')
      TubeCap.append('stop').attr('stop-color', '#f2f2f2').attr('offset', '0.41').attr('stop-opacity', '0.90')
      TubeCap.append('stop').attr('stop-color', '#ececec').attr('offset', '0.59').attr('stop-opacity', '0.90')
      TubeCap.append('stop').attr('stop-color', '#e8e8e8').attr('offset', '1.00').attr('stop-opacity', '0.90')
    },

  }
}
